import { BTAdminRep } from "helpers/globalContext/btAdmin/BTAdminContext.types";

import { APIHandler } from "utilities/apiHandler";
import { isBTAdminAuthProjectXEnabled } from "utilities/appDefaultFlags";

export interface IBTAdminContextHandler {
    get(encryptedBuilderId?: string): Promise<BTAdminRep>;
}

export class BTAdminUserInfoHandler implements IBTAdminContextHandler {
    isLegacy = false;

    async get(): Promise<BTAdminRep> {
        const url = isBTAdminAuthProjectXEnabled()
            ? "/apix/v1/BTAdminAccountInfo"
            : "/api/BTAdminAccountInfo/";

        const btadminUser = await APIHandler(url, {
            method: "GET",
            responseType: BTAdminRep,
        });

        return btadminUser;
    }
}
